import { tsValidateArray, tsValidateBoolean, tsValidateString } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
const Validator_ModifiableProps = {
    label: tsValidateString(),
    urlPrefix: tsValidateString(),
    groupParams: tsValidateArray({
        param: tsValidateString(),
        multiSelection: tsValidateBoolean(),
    }),
};
const Validator_GeneratedProps = {};
export const DBDef_FHIRResource = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1', '1.0.0'],
    dbKey: 'fhir-resource',
    entityName: 'FHIRResource',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'fhir-resource'
    },
    backend: {
        name: 'fhir-resource'
    }
};
//# sourceMappingURL=db-def.js.map